<template>
  <v-main>
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <v-card>
        <v-card-title>
          <span class="text-h5">Data Artikel</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      v-model="currentData.judul"
                      label="Judul"
                      clearable
                      dense
                      outlined
                      required
                    ></v-text-field>
                    <v-textarea
                      v-model="currentData.konten"
                      label="Konten"
                      clearable
                      dense
                      outlined
                      required
                    ></v-textarea>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="currentData.judul_en"
                      label="Judul Inggris"
                      clearable
                      dense
                      outlined
                      required
                    ></v-text-field>
                    <v-textarea
                      v-model="currentData.konten_en"
                      label="Konten Inggris"
                      clearable
                      dense
                      outlined
                      required
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-combobox
                  v-model="currentData.selectedKategori"
                  label="Kategori"
                  clearable
                  dense
                  outlined
                  :items="currentData.items_kategori"
                  item-text="nama"
                ></v-combobox>
                <v-combobox
                  v-model="currentData.selectedHide"
                  label="Publish"
                  clearable
                  dense
                  outlined
                  :items="currentData.items_hide"
                  item-text="name"
                ></v-combobox>
                <v-file-input
                  v-model="filefoto"
                  label="Foto Thumbnail (Cover)"
                  accept="image/*"
                  prepend-icon="mdi-image"
                  clearable
                  dense
                  outlined
                  @change="loadImage"
                >
                </v-file-input>
                <v-row v-if="filefoto" class="my-5">
                  <v-col cols="12" sm="6" md="5">
                    <v-responsive :aspect-ratio="16 / 9">
                      <v-img
                        :key="currentData.fotoKey"
                        :src="currentData.FotoUrl"
                        contain
                      ></v-img>
                    </v-responsive>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div>
              <CardGallery />
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel"> Close </v-btn>
          <v-btn color="blue darken-1" text @click="doSave"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-main>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { useRouter } from "../../utils/utils.js";
import ArtikelService from "../../services/web_content/ArtikelService";
import KategoriArtikelService from "../../services/web_content/KategoriArtikelService";
import CommonService from "../../services/CommonService";
import CardGallery from "../../components/CardGallery.vue";

// Router instance for navigation
const router = useRouter();

// Static data
const breadcrumbs = [
  {
    text: "Artikel",
    disabled: false,
    href: "/webcontent/artikel",
  },
  {
    text: "Tambah Artikel",
    disabled: true,
    href: "breadcrumbs_dashboard",
  },
];

// Reactive state
const filefoto = ref(null);
const currentData = reactive({
  judul: "",
  konten: null,
  judul_en: "",
  konten_en: null,
  selectedKategori: "",
  selectedHide: "",
  foto_url: "",
  fotoKey: 0,
  FotoUrl: "",
  items_hide: [
    { code: 1, name: "Publish" },
    { code: 2, name: "Hide" },
  ],
  items_kategori: [],
});

// Functions
const loadImage = (file) => {
  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      currentData.FotoUrl = e.target.result;
      currentData.fotoKey++; // Force re-render of v-img if needed
    };
    reader.readAsDataURL(file);
  } else {
    currentData.FotoUrl = "";
    currentData.foto_url = null;
  }
};

const getListKategori = async () => {
  try {
    const res = await KategoriArtikelService.kategoriArtikelListAll();
    currentData.items_kategori = res.data.list_data;
  } catch (err) {
    console.error(err);
    CommonService.showErrorToast("Gagal memuat kategori.");
  }
};

const doSave = async () => {
  if (!currentData.judul || !currentData.konten || !filefoto.value) {
    CommonService.showWarningToast("Lengkapi judul, konten, dan foto!");
    return;
  }

  try {
    await ArtikelService.create(currentData, filefoto.value);
    CommonService.showSuccessToast("Tambah artikel berhasil");
    router.push("/webcontent/artikel");
  } catch (err) {
    console.error(err);
    CommonService.showErrorToast("Tambah artikel gagal. Coba lagi");
  }
};

const cancel = () => {
  router.push("/webcontent/artikel");
};

// Lifecycle hook
onMounted(() => {
  getListKategori();
});
</script>
